import * as types from 'store/projectCreation/projectCreationTypes'

const initialState = {
  postScreeninBuffer: 24
}

const projectInquiryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_LIST_MATCH_CROWDS_SUCCEEDED: {
      const { crowds } = action.payload
      return {
        ...state,
        customCrowds: crowds,
      }
    }
    case types.FETCH_MARKETS_WITH_NPI_SUCCEEDED: {
      const { markets } = action.payload

      return {
        ...state,
        npiMarkets: markets,
      }
    }
    case types.POST_CREATE_PROJECT: {
      return {
        ...state,
        loading: true,
        submitting: true,
      }
    }
    case types.POST_CREATE_PROJECT_SUCCEEDED: {
      return {
        ...state,
        ...action.payload,
        loading: false,
        submitting: false,
      }
    }
    case types.POST_CREATE_PROJECT_FAILED: {
      return {
        ...state,
        loading: false,
        submitting: false,
      }
    }
    default:
      return state
  }
}

export default projectInquiryReducer
